import {Component} from '@angular/core';
@Component({
  selector: 'triangles',
  templateUrl:'./checkout.payment/triangles.pug'
})
export class Triangles { }